import { useEffect, useState } from 'react';
import { Card, Table, Button } from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import PageHeader1 from '../../components/common/PageHeader1';
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";
import apiClient from "../../utils/api";
import { toast } from 'react-toastify';

function DriversList() {
    const [drivers, setDrivers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [perPage] = useState(10);

    const fetchDrivers = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/drivers?page=${currentPage}&per_page=${perPage}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setDrivers(response.data.data);
            setTotalPages(Math.ceil(response.data.total / response.data.per_page));
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading drivers');
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    useEffect(() => {
        fetchDrivers();
    }, [currentPage]);

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this driver?')) return;
        
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.delete(`accounts/drivers/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Driver deleted successfully');
            fetchDrivers();
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to delete driver');
        }
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 
                    pagetitle='Drivers List' 
                    righttitle='Add Driver' 
                    link='/accounts/drivers-add' 
                    routebutton={true}
                    permission="drivers.create"
                />
                <Card className="mb-3">
                    <Card.Body>
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Full Name</th>
                                    <th>Email</th>
                                    <th>Contact Number</th>
                                    <th>Assigned Valet Locations</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {drivers.map((driver) => (
                                    <tr key={driver.id}>
                                        <td>#{driver.id}</td>
                                        <td>{driver.name}</td>
                                        <td>{driver.email || 'Not provided'}</td>                                                    
                                        <td>{driver.contact_number}</td>
                                        <td>
                                            {driver.exit_location_names?.length > 0 
                                                ? driver.exit_location_names.join(', ')
                                                : 'Not Assigned'
                                            }
                                        </td>
                                        <td>
                                            <span className={`badge ${driver.is_active ? 'bg-success' : 'bg-warning'}`}>
                                                {driver.is_active ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="btn-group" role="group">
                                                <Button 
                                                    variant="info"
                                                    onClick={() => window.location.href = `/accounts/driver-incidents/${driver.id}`}
                                                >
                                                    Incidents
                                                </Button>
                                                <Button 
                                                    variant="secondary"
                                                    onClick={() => window.location.href = `/accounts/attendance/history/${driver.id}`}
                                                >
                                                    History
                                                </Button>
                                                <EditButton
                                                    to={`${process.env.PUBLIC_URL}/accounts/drivers-edit/${driver.id}`}
                                                    permission="drivers.edit"
                                                />
                                                <DeleteButton
                                                    permission="drivers.delete"
                                                    onDelete={() => handleDelete(driver.id)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-center mt-3">
                            <Pagination>
                                <Pagination.First 
                                    onClick={() => handlePageChange(1)} 
                                    disabled={currentPage === 1}
                                />
                                <Pagination.Prev 
                                    onClick={() => handlePageChange(currentPage - 1)} 
                                    disabled={currentPage === 1}
                                />
                                
                                {[...Array(totalPages)].map((_, idx) => (
                                    <Pagination.Item
                                        key={idx + 1}
                                        active={idx + 1 === currentPage}
                                        onClick={() => handlePageChange(idx + 1)}
                                    >
                                        {idx + 1}
                                    </Pagination.Item>
                                ))}
                                
                                <Pagination.Next 
                                    onClick={() => handlePageChange(currentPage + 1)} 
                                    disabled={currentPage === totalPages}
                                />
                                <Pagination.Last 
                                    onClick={() => handlePageChange(totalPages)} 
                                    disabled={currentPage === totalPages}
                                />
                            </Pagination>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default DriversList;